const initialState = {
  editChartIndex: null,
  firstVisit: true,
  applyingFilters: false,
  copiedFilter: null,
  columnWidth: '100%',
  activeChartIndex: 0,
  errorMessage: null,
  filtersFetched: false,
  hoverMap: null,
  filters: {
    methods: ['Multiple Alternative', 'Single Alternative', 'Time Series']
  },
  plots: [
    {
      origin: '',
      isLoading: false,
      showPanel: true,
      favorites: true,
      datum: null,
      useDatum: false,
      availableFilters: {
        methods: ['Multiple Alternative', 'Single Alternative', 'Time Series'],
        stats: false,
        ninetieth: false,
        tenth: false,
        min: false,
        max: false,
        average: false,
        fiftieth: false,
        sources: [],
        rivers: [],
        locations: [],
        alternatives: [],
        types: [],
      },
      lastApplied: {
        method: '',
        source: '',
        river: '',
        locations: [],
        type: '',
        alternatives: []
      },
      appliedFilters: {
        method: 'Multiple Alternative',
        stats: false,
        ninetieth: false,
        tenth: false,
        min: false,
        max: false,
        average: false,
        fiftieth: false,
        selectedStat: 'maximum',
        source: '',
        river: '',
        locations: [],
        alternatives: [],
        startDate: 1931,
        endDate: 2012,
        type: '',
        pickYear: 2012,
        selectedAlts: {},
        pickYearEnabled: false
      },
      thresholds: [],
      stages: [],
      data: [], 
      layout: {
        title: '',
        autosize: true,
        showlegend: true,
        margin: {
          l: 50, t: 50, r: 40, b: 40
        },
        legend: {},
        xaxis: {},
        yaxis: {
          fixedrange: false
        }
      },
      config: {}
    }
  ]
};

const THRESHOLD_TEMPLATE = {
  show: true,
  changed: false,
  edit: false,
  name: '',
  value: '',
  continuous: true,
  startDate: null,
  endDate: null,
  width: 2,
  dash: 'solid',
  color: '#1f77b4'
};

const PLOT_TEMPLATE = {
  isLoading: false,
  origin: '',
  showPanel: true,
  favorites: true,
  datum: null,
  useDatum: false,
  lastApplied: {
    method: '',
    source: '',
    river: '',
    locations: [],
    type: '',
    alternatives: []
  },
  availableFilters: {
    methods: ['Multiple Alternative', 'Single Alternative', 'Time Series'],
    stats: false,
    ninetieth: false,
    tenth: false,
    min: false,
    max: false,
    average: false,
    fiftieth: false,
    sources: [],
    rivers: [],
    locations: [],
    alternatives: [],
    types: []
  },
  appliedFilters: {
    method: 'Multiple Alternative',
    stats: false,
    ninetieth: false,
    tenth: false,
    min: false,
    max: false,
    average: false,
    fiftieth: false,
    source: '',
    river: '',
    locations: [],
    alternatives: [],
    startDate: 1931,
    endDate: 2012,
    type: '',
    selectedStat: 'maximum',
    selectedAlts: {},
    pickYearEnabled: false,
    pickYear: 2012
  },
  thresholds: [],
  stages: [],
  data: [], 
  layout: {
    title: '',
    autosize: true,
    showlegend: true,
    margin: {
      l: 50, t: 50, r: 40, b: 40
    },
    legend: {},
    xaxis: {},
    yaxis: {
      fixedrange: false
    }
  },
  config: {}
};

const multi = ( state = initialState, action ) => {
	// must return the same state or an updated version of the state
	const actionLookup = {
    'MULTI_SET_HOVER_MAP': () => ({
      ...state,
      hoverMap: action.hoverMap
    }),
    'MULTI_SET_ACTIVE_CHART': () => ({
      ...state,
      activeChartIndex: action.index
    }),
    'MULTI_VISIT': () => ({
      ...state,
      firstVisit: false
    }),
    'MULTI_TOGGLE_SHOW_PANEL': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            showPanel: action.display
          }
        }
      })
    }),
    'MULTI_TOGGLE_FAVORITES': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            favorites: action.bool
          }
        }
      })
    }),
    'MULTI_SET_LOADING': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            isLoading: action.loading
          }
        }
      })
    }),
    'MULTI_SET_BULK': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            bulkData: action.bulkData
          }
        }
      })
    }),
    'MULTI_EDIT_TRACE': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            data: plot.data.map((data) => {
              if(data.key !== action.chartKey){ return data }
              else { 
                return {
                  ...data,
                  ...action.changes
                }
              }
            })
          }
        }
      })
    }),
    'MULTI_EDIT_Y_AXIS': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            layout: {
              ...plot.layout,
              yaxis: {
                ...plot.layout.yaxis,
                ...action.changes
              }
            }
          }
        }
      })
    }),
    // edit a chart traces line style
    'MULTI_EDIT_CHART_LINE': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            data: plot.data.map((data) => {
              if(data.key !== action.chartKey){ return data }
              else { 
                return {
                  ...data,
                  line: {...data.line, ...action.changes }
                }
              }
            })
          }
        }
      })
    }),
    // edit the chart layout at a given index
    'MULTI_EDIT_CHART_LAYOUT': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ return plot }
        else {
          return {
            ...plot,
            layout: {
              ...plot.layout, 
              ...action.data
            }
          }
        }
      })
    }),
    // set the default filters available
    'MULTI_SET_FILTERS': () => ({
      ...state, 
      filtersFetched: true, 
      filters: {
        ...state.filters, 
        ...action.filters
      }
    }),
    'MULTI_SET_AVAILABLE': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){
          return plot
        } else {
          return {
            ...plot,
            availableFilters: {
              ...plot.availableFilters,
              ...action.filters
            }
          }
        }
      })
    }),
    // clears the filters at a chart
    'MULTI_CLEAR_FILTERS': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){ 
          return plot
        } else {
          return {
            ...PLOT_TEMPLATE
          }
        }
      })
    }),
    
    // set a error message
    'MULTI_SET_ERROR': () => ({...state, errorMessage: action.errorMessage}), 
    
    // clear the error message
    'MULTI_CLEAR_ERROR': () => ({...state, errorMessage: null}), 

    // open a line styles panel
    'MULTI_OPEN_LINE_STYLES': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showFilters: false,
            showThresholds: false,
            showSettings: false,
            showStats: false,
            showLineStyles: true
          }
        })
      }
    },

    // close the line styles panel
    'MULTI_CLOSE_LINE_STYLES': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showLineStyles: false
          }
        })
      }
    }, 
    
    // open a plots filter dialog
    'MULTI_OPEN_FILTER': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showFilters: true,
            showThresholds: false,
            showSettings: false,
            showStats: false,
            showLineStyles: false
          }
        })
      }
    },

    // close filter
    'MULTI_CLOSE_FILTER': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showFilters: false
          }
        })
      }
    }, 

    // open a plots thresholds dialog
    'MULTI_OPEN_THRESHOLDS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showThresholds: true,
            showFilters: false,
            showSettings: false,
            showStats: false,
            showLineStyles: false
          }
        })
      }
    },

    // close thresholds
    'MULTI_CLOSE_THRESHOLDS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showThresholds: false
          }
        })
      }
    }, 

    // open stats
    'MULTI_SHOW_STATS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showStats: true,
            showFilters: false,
            showThresholds: false,
            showSettings: false,
            showLineStyles: false
          }
        })
      }
    }, 

    // close stats
    'MULTI_CLOSE_STATS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showStats: false,
            showFilters: true // when we close the stats, we still want to see the filters
          }
        })
      }
    }, 

    // open a plots thresholds dialog
    'MULTI_OPEN_SETTINGS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showSettings: true,
            showFilters: false,
            showThresholds: false,
            showStats: false,
            showLineStyles: false
          }
        })
      }
    },

    // close thresholds
    'MULTI_CLOSE_SETTINGS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            showSettings: false
          }
        })
      }
    },

    'MULTI_EDIT_DATUM': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){
          return {...plot}
        }
        return {
          ...plot,
          datum: action.datum
        }
      }) 
    }),

    'MULTI_TOGGLE_DATUM': () => ({
      ...state,
      plots: state.plots.map((plot, index) => {
        if(index !== action.index){
          return {...plot}
        }
        return {
          ...plot,
          useDatum: action.useDatum
        }
      }) 
    }),

    'MULTI_CLEAR_THRESHOLDS': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            thresholds: []
          }
        })
      }
    },

    // add a new threshold
    'MULTI_ADD_THRESHOLD': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          const { appliedFilters } = plot;
          const { locations, type } = appliedFilters;

          return {
            ...plot,
            thresholds: plot.thresholds.concat(
              {key: `threshold-${plot.thresholds.length}`, 
              ...THRESHOLD_TEMPLATE, 
              ...action.data,
              location_id: locations && locations[0],
              type_id: type
            })
          }
        })
      }
    },

    // remove a trhreshold
    'MULTI_REMOVE_THRESHOLD': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            thresholds: plot.thresholds.filter(({key}) => key !== action.key)
          }
        })
      }
    },

    // change threshold
    'MULTI_EDIT_THRESHOLD': () => {
      return {
        ...state,
        plots: state.plots.map((plot, i) => {
          if(i !== action.plotIndex){ return {...plot} }
          else {
            return {
              ...plot,
              thresholds: plot.thresholds.map((threshold, x) => {
                if(x !== action.thresholdIndex){ return {...threshold}}
                else {
                  return {
                    ...threshold,
                    ...action.changes
                  }
                }
              })
            }
          }
        })
      }
    },

    // add a new threshold
    'MULTI_ADD_STAGE': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            stages: plot.stages.concat({key: `stage-${plot.stages.length}`, ...THRESHOLD_TEMPLATE, ...action.data})
          }
        })
      }
    },

    // remove a trhreshold
    'MULTI_REMOVE_STAGE': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            stages: plot.stages.filter(({key}) => key !== action.key)
          }
        })
      }
    },

    'MULTI_CLEAR_STAGES': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){
            return {...plot}
          }
          return {
            ...plot,
            stages: []
          }
        })
      }
    },

    // change threshold
    'MULTI_EDIT_STAGE': () => {
      return {
        ...state,
        plots: state.plots.map((plot, i) => {
          if(i !== action.plotIndex){ return {...plot} }
          else {
            return {
              ...plot,
              stages: plot.stages.map((stage, x) => {
                if(x !== action.stageIndex){ return {...stage}}
                else {
                  return {
                    ...stage,
                    ...action.changes
                  }
                }
              })
            }
          }
        })
      }
    },
    
    // remove a chart
    'MULTI_REMOVE_CHART': () => {
      return {
        ...state,
        editChartIndex: null,
        plots: state.plots.filter((plot, i) => i !== action.index)
      }
    }, 
    
    // add a chart
    'MULTI_ADD_CHART': () => {
      return {
        ...state,
        editChartIndex: null,
        plots: action.location === 'end' ? state.plots.concat({...PLOT_TEMPLATE, origin: action.origin}) : [{...PLOT_TEMPLATE, origin: action.origin}].concat(state.plots)
      }
    },
    
    // change number of columns
    'MULTI_CHANGE_COL_WIDTH': () => {
      return {
        ...state,
        columnWidth: action.width,
        plots: state.plots.map(plot => {
          return {
            ...plot,
            layout: {
              ...plot.layout,
              colWidth: action.width
            }
          }
        })
      }
    }, 
    
    // copy a filter
    'MULTI_COPY_FILTER': () => {
      return {
        ...state,
        copiedFilter: action.copiedFilter
      }
    }, 
    
    // paste copied filter
    'MULTI_PASTE_FILTER': () => {
      return {
        ...state,
        plots: state.plots.map((plot, i) => {
          if(i !== action.index){ return {...plot} }
          else {
            return {
              ...plot,
              availableFilters: { // set the available filters to the master list
                ...state.filters,
              },
              appliedFilters: { // change the applied filters to the pasted filters
                ...plot.appliedFilters,
                ...action.pasteFilter
              }
            }
          }
        }),
      }
    }, 
    
    // change fitlers
    'MULTI_SET_APPLIED_FILTER': () => {
      return {
        ...state,
        plots: state.plots.map((plot, i) => {
          if(i !== action.index){ return {...plot} }
          else {
            return {
              ...plot,
              appliedFilters: {
                ...plot.appliedFilters,
                ...action.changes
              }
            }
          }
        }),
      }
    }, 
    
    // show loading state for plot
    'MULTI_LOADING_DATA': () => {
      return {
        ...state,
        editChartIndex: action.index,
        applyingFilters: true,
      } 
    },

    'MULTI_SET_LAST_APPLIED': () => {
      return {
        ...state,
        plots: state.plots.map((plot, index) => {
          if(index === action.index){
            return {
              ...plot,
              lastApplied: {
                ...plot.lastApplied,
                ...action.filters
              }
            }
          } else {
            return { ...plot }
          }
        })
      }
    },

    // clear loading state for chart
    'MULTI_CLEAR_LOADING_STATE': () => {
      return {
        ...state,
        editChartIndex: null,
        applyingFilters: false,
      } 
    },

    // set the plot data and clear loading state
    'MULTI_SET_PLOT_DATA': () => {
      return {
        ...state,
        editChartIndex: null,
        appliedFilters: false,
        plots: state.plots.map((plot, index) => {
          if(index !== action.index){ return {...plot}}
          else {
            return {
              ...plot,
              data: action.data,
              layout: {
                ...plot.layout,
              }
            }
          }
        })
      } 
    },
  };
  return actionLookup[action.type] ? actionLookup[action.type](state, action) : {...state}; // if the action type exists, execute action, otherwise returns default state
};

export default multi;


// WEBPACK FOOTER //
// ./src/store/reducers/multi.js